/* Iron Threads theme JS — vanilla, no dependencies.
   Modules: analytics stub · menu · mega/dropdown · cart drawer (AJAX) ·
   PDP variant picker · size filters (collection + shop-your-size) ·
   predictive search · reveals · sticky mobile CTA. */

(function () {
  "use strict";

  var esc = function (s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  };

  var money = function (cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || "en", {
        style: "currency", currency: (window.ItTheme && ItTheme.currency) || "USD"
      }).format(cents / 100);
    } catch (e) { return "$" + (cents / 100).toFixed(2); }
  };

  // ---------- analytics stub ----------
  window.dataLayer = window.dataLayer || [];
  function itTrack(ev, detail) {
    window.dataLayer.push({ event: "it_" + ev, detail: detail || "", ts: Date.now() });
  }
  document.addEventListener("click", function (e) {
    var el = e.target.closest("[data-track]");
    if (el) itTrack(el.getAttribute("data-track"), el.getAttribute("data-detail"));
  });

  // ---------- mobile menu ----------
  var menuBtn = document.querySelector("[data-menu-open]");
  var menu = document.getElementById("MobileMenu");
  if (menuBtn && menu) {
    var closeBtn = menu.querySelector("[data-menu-close]");
    var setMenu = function (open) {
      menu.classList.toggle("open", open);
      menuBtn.setAttribute("aria-expanded", String(open));
      document.body.style.overflow = open ? "hidden" : "";
      if (open && closeBtn) closeBtn.focus(); else menuBtn.focus();
    };
    menuBtn.addEventListener("click", function () { setMenu(true); });
    if (closeBtn) closeBtn.addEventListener("click", function () { setMenu(false); });
    menu.addEventListener("click", function (e) { if (e.target.closest("a")) setMenu(false); });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && menu.classList.contains("open")) setMenu(false);
    });
  }

  // ---------- header dropdown keyboard toggle ----------
  document.querySelectorAll('.nav-main [aria-haspopup="true"]').forEach(function (btn) {
    btn.addEventListener("click", function () {
      var open = btn.getAttribute("aria-expanded") === "true";
      btn.setAttribute("aria-expanded", String(!open));
    });
    // focus opens the panel, so reset the flag on the way out or the trigger
    // would claim to be expanded while the panel is shut
    btn.addEventListener("blur", function () {
      btn.setAttribute("aria-expanded", "false");
    });
    btn.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        btn.setAttribute("aria-expanded", "false");
        btn.blur();
      }
    });
  });

  // ---------- cart drawer ----------
  var root = document.getElementById("CartDrawerRoot");
  function renderCart(cart) {
    if (!root) return;
    var items = root.querySelector(".cd-items");
    var sub = root.querySelector("[data-cart-subtotal]");
    var counts = document.querySelectorAll("[data-cart-count]");
    counts.forEach(function (c) { c.textContent = cart.item_count; c.hidden = cart.item_count === 0; });
    if (sub) sub.textContent = money(cart.total_price);
    if (!items) return;
    if (cart.items.length === 0) {
      items.innerHTML = '<p class="cd-empty">Your cart is empty. <br><a href="' + (ItTheme.shoesUrl || "/collections/all") + '" style="border-bottom:1px solid var(--red);font-weight:600">Shop wrestling shoes</a></p>';
      return;
    }
    items.innerHTML = cart.items.map(function (it) {
      var size = (it.options_with_values || []).map(function (o) { return esc(o.value); }).join(" / ");
      return '<div class="cd-item" data-line-key="' + esc(it.key) + '">' +
        '<img src="' + esc(it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/, "_180x$1$2") : "") + '" alt="">' +
        '<div><div class="cd-item-title">' + esc(it.product_title) + "</div>" +
        (size ? '<span class="cd-item-size">Size ' + size + "</span>" : "") +
        '<div class="cd-qty"><button type="button" data-qty="-1" aria-label="Decrease quantity">−</button><span>' + it.quantity + '</span><button type="button" data-qty="1" aria-label="Increase quantity">+</button></div>' +
        '<button type="button" class="cd-remove" data-remove>Remove</button></div>' +
        '<span class="cd-item-price">' + money(it.final_line_price) + "</span></div>";
    }).join("");
  }
  function openCart() {
    if (!root) return;
    root.classList.add("open");
    root.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
  }
  function closeCart() {
    if (!root) return;
    root.classList.remove("open");
    root.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }
  function refreshCart(open) {
    fetch("/cart.js").then(function (r) { return r.json(); }).then(function (c) {
      renderCart(c); if (open) openCart();
    });
  }
  if (root) {
    root.querySelector(".cart-scrim").addEventListener("click", closeCart);
    root.querySelector("[data-cart-close]").addEventListener("click", closeCart);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeCart(); });
    document.querySelectorAll("[data-cart-open]").forEach(function (b) {
      b.addEventListener("click", function (e) { e.preventDefault(); refreshCart(true); });
    });
    root.addEventListener("click", function (e) {
      var line = e.target.closest(".cd-item");
      if (!line) return;
      var key = line.getAttribute("data-line-key");
      if (e.target.closest("[data-remove]")) {
        fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: key, quantity: 0 }) })
          .then(function (r) { return r.json(); }).then(renderCart);
      } else if (e.target.closest("[data-qty]")) {
        var delta = parseInt(e.target.closest("[data-qty]").getAttribute("data-qty"), 10);
        var current = parseInt(line.querySelector(".cd-qty span").textContent, 10);
        fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: key, quantity: Math.max(0, current + delta) }) })
          .then(function (r) { return r.json(); }).then(renderCart);
      }
    });
    refreshCart(false);
  }

  // ---------- PDP: size chips → variant ----------
  var buy = document.querySelector("[data-pdp]");
  if (buy) {
    var variants = JSON.parse(buy.querySelector("[data-variants-json]").textContent);
    var idInput = buy.querySelector('input[name="id"]');
    var atc = buy.querySelector(".pdp-atc");
    var priceEl = buy.querySelector(".pdp-price");
    var cmEl = buy.querySelector("[data-cm]");
    var chips = buy.querySelectorAll(".pdp-size");
    chips.forEach(function (chip) {
      chip.addEventListener("click", function () {
        if (chip.classList.contains("oos")) return;
        chips.forEach(function (c) { c.setAttribute("aria-pressed", "false"); });
        chip.setAttribute("aria-pressed", "true");
        var v = variants.find(function (x) { return String(x.id) === chip.getAttribute("data-variant-id"); });
        if (!v) return;
        idInput.value = v.id;
        if (priceEl) priceEl.textContent = money(v.price);
        if (cmEl) cmEl.textContent = chip.getAttribute("data-full") !== chip.textContent.trim() ? chip.getAttribute("data-full") : "";
        atc.disabled = false;
        atc.textContent = atc.getAttribute("data-label-add") || "Add to cart";
        itTrack("size_selected", v.title);
      });
    });
    var form = buy.querySelector("form[data-ajax-cart]");
    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        if (!idInput.value) return;
        atc.disabled = true;
        atc.textContent = "Adding…";
        fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: parseInt(idInput.value, 10), quantity: 1 }) })
          .then(function (r) { if (!r.ok) throw new Error("add failed"); return r.json(); })
          .then(function () { itTrack("add_to_cart", idInput.value); atc.disabled = false; atc.textContent = atc.getAttribute("data-label-add") || "Add to cart"; refreshCart(true); })
          .catch(function () { atc.disabled = false; atc.textContent = "Try again"; });
      });
    }
    // gallery thumbs
    var mainImg = document.querySelector(".pdp-gallery .main-img img");
    document.querySelectorAll(".pdp-thumbs button").forEach(function (t) {
      t.addEventListener("click", function () {
        document.querySelectorAll(".pdp-thumbs button").forEach(function (x) { x.classList.remove("active"); });
        t.classList.add("active");
        if (mainImg) { mainImg.src = t.getAttribute("data-src"); mainImg.alt = t.querySelector("img").alt; }
      });
    });
  }

  // ---------- size filtering (collection + shop-your-size + home row) ----------
  document.querySelectorAll("[data-size-filter]").forEach(function (zone) {
    var chips = zone.querySelectorAll(".chip[data-size]");
    var gridSel = zone.getAttribute("data-size-filter");
    var grid = document.querySelector(gridSel);
    if (!grid) return;
    var empty = document.querySelector(zone.getAttribute("data-empty") || "__none");
    var count = document.querySelector(zone.getAttribute("data-count") || "__none");
    chips.forEach(function (chip) {
      chip.addEventListener("click", function () {
        chips.forEach(function (c) { c.setAttribute("aria-pressed", "false"); });
        chip.setAttribute("aria-pressed", "true");
        var size = chip.getAttribute("data-size");
        var shown = 0;
        grid.querySelectorAll("[data-sizes]").forEach(function (card) {
          var sizes = (card.getAttribute("data-sizes") || "").split(",").filter(Boolean);
          var ok = size === "all" || sizes.indexOf(size) !== -1;
          card.classList.toggle("prod-hidden", !ok);
          if (ok && !card.classList.contains("stock-hidden")) shown++;
        });
        if (count) count.textContent = shown + (shown === 1 ? " product" : " products") + (size === "all" ? "" : " in size " + size);
        if (empty) empty.classList.toggle("show", shown === 0);
        itTrack("size_filter", size);
      });
    });
  });

  // ---------- collection: in-stock toggle + in-stock-first sort ----------
  (function () {
    var toggle = document.getElementById("collInStock");
    var grid = document.getElementById("collGrid");
    if (!grid) return;
    var count = document.getElementById("collCount");
    var empty = document.getElementById("collEmpty");

    function apply() {
      var inStockOnly = !toggle || toggle.checked;
      var shown = 0;
      grid.querySelectorAll(".prod-card").forEach(function (card) {
        var out = card.classList.contains("is-out");
        card.classList.toggle("stock-hidden", inStockOnly && out);
        if (!(inStockOnly && out) && !card.classList.contains("prod-hidden")) shown++;
      });
      if (count) count.textContent = shown + (shown === 1 ? " product" : " products");
      if (empty) empty.classList.toggle("show", shown === 0);
    }

    if (toggle) {
      toggle.addEventListener("change", function () {
        apply();
        itTrack("stock_filter", toggle.checked ? "in_stock" : "all");
      });
    }

    var sort = document.querySelector("[data-avail-sort]");
    if (sort) {
      sort.addEventListener("change", function () {
        if (sort.value !== "in-stock-first") return;
        var cards = Array.prototype.slice.call(grid.querySelectorAll(".prod-card"));
        cards.sort(function (a, b) {
          return (a.classList.contains("is-out") ? 1 : 0) - (b.classList.contains("is-out") ? 1 : 0);
        });
        cards.forEach(function (c) { grid.appendChild(c); });
        itTrack("sort", "in_stock_first");
      });
    }

    apply();
  })();

  // ---------- predictive search ----------
  document.querySelectorAll("[data-predictive]").forEach(function (wrap) {
    var input = wrap.querySelector('input[type="search"]');
    var panel = wrap.querySelector(".predictive");
    if (!input || !panel) return;
    var t;
    input.addEventListener("input", function () {
      clearTimeout(t);
      var q = input.value.trim();
      if (q.length < 2) { panel.classList.remove("open"); return; }
      t = setTimeout(function () {
        fetch("/search/suggest.json?q=" + encodeURIComponent(q) + "&resources[type]=product&resources[limit]=6")
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var prods = (((d.resources || {}).results || {}).products) || [];
            if (!prods.length) { panel.classList.remove("open"); return; }
            panel.innerHTML = prods.map(function (p) {
              var img = p.featured_image && p.featured_image.url ? p.featured_image.url : "";
              return '<a href="' + esc(p.url) + '"><img src="' + esc(img) + '" alt=""><span class="pt">' + esc(p.title) + "</span></a>";
            }).join("");
            panel.classList.add("open");
          }).catch(function () { panel.classList.remove("open"); });
      }, 220);
    });
    document.addEventListener("click", function (e) { if (!wrap.contains(e.target)) panel.classList.remove("open"); });
  });

  // ---------- reveals + stagger ----------
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var reveals = document.querySelectorAll(".reveal, .reveal-stagger");
  if (reduce || !("IntersectionObserver" in window)) {
    reveals.forEach(function (el) { el.classList.add("in"); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); }
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
    reveals.forEach(function (el) { io.observe(el); });
  }

  // ---------- sticky mobile CTA ----------
  var sticky = document.getElementById("stickyCta");
  var heroEl = document.querySelector("[data-hero]");
  // The bar's main button mirrors the hero's main button (label and link).
  var heroMain = heroEl && heroEl.querySelector("[data-hero-main], .hero-ctas .btn-red");
  var stickyMain = sticky && sticky.querySelector("[data-sticky-main]");
  if (heroMain && stickyMain) {
    stickyMain.href = heroMain.getAttribute("href");
    stickyMain.textContent = heroMain.textContent.trim(); // v2 buttons hold only an icon besides the label
  }
  if (sticky && heroEl && "IntersectionObserver" in window) {
    var pastHero = false, nearEnd = false;
    var ends = document.querySelectorAll("[data-sticky-stop]");
    var set = function () {
      var show = pastHero && !nearEnd;
      sticky.classList.toggle("show", show);
      sticky.setAttribute("aria-hidden", String(!show));
    };
    new IntersectionObserver(function (en) { pastHero = !en[0].isIntersecting; set(); }, { threshold: 0.05 }).observe(heroEl);
    ends.forEach(function (el) {
      new IntersectionObserver(function (en) { nearEnd = en[0].isIntersecting; set(); }, { threshold: 0.05 }).observe(el);
    });
  }
})();
